import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './i18n'
import { initSentry } from './sentry'
import { App } from './App'

initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
